import Swiper, {Pagination, Autoplay, Navigation} from "swiper";

export class Slider {
  constructor() {

    document.querySelectorAll('*[slider]').forEach(slider => {

      this.registerSlider(slider)

    })
  }

  registerSlider(slider) {

    let name = slider.getAttribute('data-slider')
    let per_view = slider.getAttribute('per-view')
    let per_view_sm = slider.getAttribute('per-view-sm')
    let per_view_md = slider.getAttribute('per-view-md')
    let per_view_xs = slider.getAttribute('per-view-xs')
    let autoheight = parseInt(slider.getAttribute('autoheight'))
    let nav = slider.getAttribute('navigation')

    const modules = [Pagination, Autoplay]
    let navigation = {}
    let pagination = {}

    if (nav === 'arrow') {
      modules.shift()
      modules.push(Navigation)
      navigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    } else {
      pagination = {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="swiper-pagination-bullet"></span>'
        }
      }
    }


    const
      swiper = new Swiper('.' + name, {
        modules: modules,
        slidesPerView: per_view,
        loop: false,
        spaceBetween: 20,
        navigation: navigation,
        pagination: pagination,
        autoHeight: autoheight == 1 ? true : false,
        breakpoints: {
          300: {
            slidesPerView: per_view_xs,
          },
          480: {
            slidesPerView: per_view_sm
          },
          768: {
            slidesPerView: per_view_md
          },
          1024: {
            slidesPerView: per_view
          }
        }
      });

  }
}
